import { FaroCoreApiConst } from "@stellar/core-api-client";

/**
 * Roles offered when the workspace cannot assign managers (Scan Essential and
 * below), where every member is effectively a viewer.
 * - "invite": Group Viewer is offered because a group is selected alongside it.
 * - "change": Group Viewer is omitted since it can't be easily downgraded.
 */
const rolesWithoutManagerAssignment = {
  invite: ["COMPANY_VIEWER", "GROUP_VIEWER", "MEMBER"],
  change: ["COMPANY_VIEWER", "MEMBER"]
};

/**
 * Returns the workspace roles selectable in the given context. Workspaces that
 * can assign managers offer every role; the rest are limited to viewers and
 * "no workspace role".
 */
export function getAssignableWorkspaceRoles(context, canAssignManagers) {
  return canAssignManagers ? [...FaroCoreApiConst.allCompanyRoles] : rolesWithoutManagerAssignment[context];
}

/**
 * Gets the disabled roles based on the selected role.
 * For example an enterprise executive can't be downgraded to a project manager.
 *
 * @param selectedRole The current selected role to check
 * @returns Array filled with the roles that should be disabled
 * @see https://faro01.atlassian.net/wiki/spaces/HBWEBDEV/pages/4473782411/Workspace+Role+Hierarchy
 */
export function getDisabledRoles(selectedRole) {
  switch (selectedRole) {
    case "COMPANY_EXECUTIVE":
      return ["COMPANY_EXECUTIVE", "COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER"];
    case "COMPANY_VIEWER":
      return ["COMPANY_VIEWER", "COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER"];
    case "COMPANY_MANAGER":
      return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER", "MEMBER"];
    case "GROUP_VIEWER":
      return ["GROUP_VIEWER", "COMPANY_MANAGER", "PROJECT_MANAGER", "MEMBER"];
    case "PROJECT_MANAGER":
      return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER", "MEMBER"];
    case "MEMBER":
      return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER", "MEMBER"];
    default:
      return [];
  }
}